import { AfterViewInit, Component, Inject, Input, OnInit, Optional, ViewChild } from "@angular/core";
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, NgModel } from "@angular/forms";
import { ValueAccessorBase } from "../../../objects/common/valueAccessorBase";

@Component({
    selector: 'form-input',
    templateUrl: './formInput.component.html',
    moduleId: module.id.toString(),
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: FormInputComponent, multi: true }
    ],
})
export class FormInputComponent extends ValueAccessorBase<string> implements OnInit, AfterViewInit {
    @Input() public hasErrors: boolean = false;
    @Input() public type: string;
    @Input() public name: string;
    @Input() public label: string;
    @Input() public disabled: boolean;
    @Input() public form: NgForm;
    @Input() public placeholder: string;
    @Input() public isPlaceholderNeed: boolean = false;
    @Input() public autofocus: boolean = false;

    @ViewChild(NgModel) model: NgModel;

    public stringHelper = String;

    constructor(@Optional() @Inject(NG_VALIDATORS) private validators: Array<any>, @Optional() @Inject(NG_ASYNC_VALIDATORS) private asyncValidators: Array<any>) {
        super();
    }

    ngOnInit() {
        this.type = this.type || "text";
        this.disabled = this.disabled || false;
    }

    ngAfterViewInit() {
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    }
}



// WEBPACK FOOTER //
// ./app/components/common/formInput/formInput.component.ts